import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useContext, useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { StoreContext } from "../store/Store";
import DashboardBarChart from "../charts/DashboardBarChart";
import DashboardPieChart from "../charts/DashboardPieChart";
import DashboardLineChart from "../charts/DashboardLineChart";
import DashboardDonutChart from "../charts/DashboardDonutChart";

const TextGeneratorLayer = () => {
  const [chats, setChats] = useState([]);
  const [chatInput, setChatInput] = useState("");
  const [conversationHistory, setConversationHistory] = useState([]);
  const { chatResponseLoader, aiChatBot, userid } = useContext(StoreContext);

  const bottomRef = useRef(null);

  useEffect(() => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chats, chatResponseLoader]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!chatInput.trim()) return;

    const configid = localStorage.getItem("configid");
    const userMessage = chatInput.trim();

    setChats((prev) => [...prev, { type: "user", text: userMessage }]);
    setChatInput("");
    const newHistory = [...conversationHistory, { user: userMessage }];

    const aiResponse = await aiChatBot({
      configid,
      conversation_history: newHistory,
    });

    console.log(newHistory);

    let assistantReply = null;
    if (Array.isArray(aiResponse) && aiResponse.length > 0) {
      if (aiResponse[0].metric_name && aiResponse[0].chart_type) {
        assistantReply = aiResponse[0].chat_response;
        setChats((prev) => [
          ...prev,
          ...aiResponse.map((item) => ({
            type: "ai-biz",
            metric_name: item.metric_name,
            metric_description: item.metric_description,
            chart_type: item.chart_type,
            value: item.value,
            chat_response: item.chat_response,
          })),
        ]);
      } else {
        assistantReply = aiResponse[0].chat_response;
        setChats((prev) => [
          ...prev,
          ...aiResponse.map((item) => ({
            type: "ai",
            text: item.chat_response,
          })),
        ]);
      }
    } else if (aiResponse) {
      assistantReply = aiResponse.chat_response || String(aiResponse);
      setChats((prev) => [...prev, { type: "ai", text: assistantReply }]);
    }

    // Update conversation history with assistant's reply
    if (assistantReply !== null) {
      setConversationHistory((prev) => {
        const updated = [...newHistory];
        updated[updated.length - 1] = {
          ...updated[updated.length - 1],
          assistant: assistantReply,
        };
        return updated;
      });
    }
  }

  const renderChart = (chartType, metricData, i) => {
    switch (chartType) {
      case "Bar Chart":
        return <DashboardBarChart key={i} metricData={metricData} />;
      case "Pie Chart":
        return <DashboardPieChart key={i} metricData={metricData} />;
      case "Donut Chart":
        return <DashboardDonutChart key={i} metricData={metricData} />;
      case "Line Chart":
        return <DashboardLineChart key={i} metricData={metricData} />;
      default:
        return <p key={i}>No chart type found for {chartType}</p>;
    }
  };

  return (
    <div className="row gy-4 flex-wrap-reverse ">
      <div className="col-12">
        <div
          className="chat-main card overflow-hidden"
          style={{
            height: "calc(100% - 10px)",
          }}
        >
          <div className="chat-sidebar-single gap-8 justify-content-between cursor-default flex-nowrap">
            <div className="d-flex align-items-center gap-16">
              <Link
                to="/"
                className="text-primary-light text-2xl line-height-1"
              >
                <i className="ri-arrow-left-line" />
              </Link>
              <h6 className="text-lg mb-0 text-line-1">Cloocus Chat Assistant</h6>
              {/* <h6 className="text-lg mb-0 text-line-1">{userid && (userid == 132 ? "Cloocus" : "VIZI 360")} Chat Assistant</h6> */}
            </div>
          </div>
          {chats.length > 0 ? (
            <div className="chat-message-list max-h-612-px min-h-612-px">
              {chats.map((chat, idx) => {
                // User message
                if (chat.type === "user") {
                  return (
                    <div
                      key={idx}
                      className="d-flex align-items-start justify-content-between gap-16 border-bottom border-neutral-200 pb-16 mb-16"
                    >
                      <div className="d-flex align-items-center gap-16">
                        <div className="img overflow-hidden flex-shrink-0">
                          <img
                            src="assets/logo/avatar.png"
                            alt="user_icon"
                            className="w-44-px h-44-px rounded-circle object-fit-cover"
                          />
                        </div>
                        <div className="info flex-grow-1">
                          <h6 className="text-lg mb-4">User</h6>
                          <p className="mb-0 text-secondary-light text-sm">
                            {chat.text}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                }

                // AI Business/Chart response
                if (chat.type === "ai-biz") {
                  return (
                    <div
                      key={idx}
                      className="border-bottom border-neutral-200 pb-16 mb-16"
                      style={{ width: "75%" }}
                    >
                      <div className="d-flex align-items-center gap-16">
                        <div className="img overflow-hidden flex-shrink-0">
                          <img
                            src="assets/logo/bot.jpg"
                            alt="ai_icon"
                            className="w-44-px h-44-px rounded-circle object-fit-cover"
                          />
                        </div>
                        <div className="info" style={{ width: "100%" }}>
                          <h6 className="text-lg mb-16 mt-8">Cloocus</h6>
                          {/* <h6 className="text-lg mb-16 mt-8">{userid && (userid == 132 ? "Cloocus" : "VIZI 360")}</h6> */}
                          <p className="fw-semibold text-primary-light my-8">
                            {chat.metric_name}
                          </p>
                          <p className="mb-8 text-secondary-light text-sm">
                            {chat.metric_description}
                          </p>
                          <div className="mb-16 text-secondary-light text-sm">
                            <p style={{ fontWeight: "600", fontSize: "18px" }}>
                              Result:
                            </p>
                            <div className="d-flex gap-2">
                              {chat.value && chat.value.length > 0 ? (
                                chat.value.map((value, i) => (
                                  <div
                                    key={i}
                                    className="d-flex border border-rounded p-4 justify-content-center align-items-center"
                                  >
                                    <p className="m-0">
                                      <span style={{ fontSize: "18px" }}>
                                        {value.name ||
                                          value.product_name ||
                                          value.id}
                                      </span>
                                      ,{" "}
                                      <span
                                        style={{
                                          fontSize: "18px",
                                          fontWeight: "600",
                                        }}
                                      >
                                        {value.value || value.total_sales}
                                      </span>
                                    </p>
                                  </div>
                                ))
                              ) : (
                                <p className="text-secondary-light text-sm">
                                  No data available for this metric.
                                </p>
                              )}
                            </div>
                          </div>
                          <div
                            className="col-12 col-md-6 mb-8"
                            style={{ width: "100%" }}
                          >
                            {Array.isArray(chat.value) &&
                            chat.value.length > 0 ? (
                              renderChart(chat.chart_type, chat, idx)
                            ) : (
                              <p className="text-secondary-light text-sm"></p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div ref={bottomRef} />
                    </div>
                  );
                }

                // Default AI text response
                return (
                  <div
                    key={idx}
                    className="d-flex align-items-start justify-content-between gap-16 border-bottom border-neutral-200 pb-16 mb-16"
                  >
                    <div className="d-flex align-items-center gap-16">
                      <div className="img overflow-hidden flex-shrink-0">
                        <img
                          src="assets/logo/bot.jpg"
                          alt="ai_icon"
                          className="w-44-px h-44-px rounded-circle object-fit-cover"
                        />
                      </div>
                      <div className="info flex-grow-1">
                        <h6 className="text-lg mb-4">Cloocus</h6>
                        <p className="mb-0 text-secondary-light text-sm">
                          {chat.text}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}

              {chatResponseLoader && (
                <div className="d-flex align-items-start justify-content-between gap-16 border-bottom border-neutral-200 pb-16 mb-16">
                  <div className="d-flex align-items-center gap-16">
                    <div className="img overflow-hidden flex-shrink-0">
                      <img
                        src="assets/logo/bot.jpg"
                        alt="ai_icon"
                        className="w-44-px h-44-px rounded-circle object-fit-cover"
                      />
                    </div>
                    <div className="info flex-grow-1">
                      <h6 className="text-lg mb-4">Cloocus</h6>
                      <div className="VIZI 360ChatLoader"></div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="dashboardChatInterface max-h-612-px min-h-612-px">
              <h3>
                Meet <span className="dashboardChatInterfaceLogo">Cloocus</span>,
              </h3>
              <h3>your personal AI assistant</h3>
            </div>
          )}

          <form
            onSubmit={handleSubmit}
            className="chat-message-box"
            autoComplete="off"
          >
            <input
              type="text"
              name="chatMessage"
              placeholder="Message Cloocus"
              value={chatInput}
              onChange={(e) => setChatInput(e.target.value)}
              autoFocus
              className="flex-grow-1 chat-bot-input"
              disabled={chatResponseLoader}
            />
            <button
              type="submit"
              className="w-44-px h-44-px d-flex justify-content-center align-items-center radius-8 text-white bg-hover-primary-700 text-lg"
              aria-label="Send message"
              style={{
                backgroundColor: "#3a80c2"
              }}
              disabled={chatResponseLoader || !chatInput.trim()}
            >
              <Icon icon="f7:paperplane" />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TextGeneratorLayer;
